import React from "react";
import { orderBy } from "lodash";
import ChartSector from "@/shared/ui/Chart/chartSector";
import { DimensionWithScores } from "@/features/people/hooks/useDimensionsWithScores";
import ConfirmModal from "@/shared/widgets/Confirm";

interface CompetencyGraphSectorProps {
  dimensions: DimensionWithScores[];
  wedgeAngle: number;
  midX: number;
  midY: number;
  sectorRadius: number;
  onClick: (sector: DimensionWithScores) => void;
}

const CompetencyGraphSectors: React.FC<CompetencyGraphSectorProps> = ({
  dimensions,
  wedgeAngle,
  midX,
  midY,
  sectorRadius,
  onClick,
}) => {
  const dimensionsSortedByScore = orderBy(dimensions, "score.value", "desc");

  return (
    <>
      {dimensions.map((comp, index) => {
        const compIndexByScore = dimensionsSortedByScore.findIndex(
          (d) => d.title === comp.title
        );

        let color = "grey";
        if (compIndexByScore < 3) {
          color = `green${compIndexByScore}`;
        } else if (compIndexByScore >= dimensions.length - 3) {
          color = `yellow${2 - (dimensions.length - 1 - compIndexByScore)}`;
        }

        const startAngle = wedgeAngle * index;
        const endAngle = startAngle + wedgeAngle;

        return (
          <ChartSector
            key={`competency-${comp.title}`}
            id={comp.id?.toString()}
            startAngle={startAngle}
            endAngle={endAngle}
            midX={midX}
            midY={midY}
            sectorRadius={sectorRadius}
            titleRadius={sectorRadius + 4}
            score={comp?.score?.value || 0}
            title={comp.title || ""}
            color={color}
            onClick={() => onClick(comp)}
          />
        );
      })}
    </>
  );
};

export default CompetencyGraphSectors;
